import { GridError } from '@get/api-interfaces';
import { createActionGroup, props } from '@ngrx/store';

export const GridErrorSocieteEspaceActions = createActionGroup({
  source: 'Grid Error Societe Espace',
  events: {
    'Add One Grid Error Societe Espace': props<{
      gridErrorSocieteEspace: GridError;
    }>(),
    'Delete One Grid Error Societe Espace Success': props<{ idGridError: number }>()
  }
});
